import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { useSlots } from 'vue'
import { $vfm } from 'vue-final-modal'
import { useComparisonStore } from '@store/comparison'


export default /*@__PURE__*/_defineComponent({
  __name: 'ButtonDetails',
  setup(__props) {

const slots = useSlots()

const comparisonStore = useComparisonStore()

const openModal = () => {
  $vfm.show({
    component: 'UiModalContainer',
  }, {
    classes: [],
    component: 'Modals/Compare/CompareView',
  })
}

const render = () => slots.default({
  quantity: comparisonStore.comparisonInfo.count || 0,
  openModal,
  isDeterminated: comparisonStore.comparisonInfo.isDeterminated,
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(render))
}
}

})